export default __webpack_public_path__ + "static/media/properties_card.44b402ad.jpg";